function waitForSwatchesAndClick() {
  var checkInterval = setInterval(function () {
    var queenBtn = $('button[data-value="Queen"]');
    var fqBtn = $('button[data-value="Full/Queen"]');
    if ((queenBtn.length > 0 || fqBtn.length > 0) && $('#product-variant-selected').length > 0) {
      var selectedVariant = $('#product-variant-selected').text().trim();
      var location = window.location.href;

      if ((selectedVariant === 'none' || selectedVariant === '') && (location.indexOf('set') === -1 && location.indexOf('bundle') === -1)) {
        if (queenBtn.length > 0) queenBtn.click();
        if (fqBtn.length > 0) fqBtn.click();
      } 
      else if (location.indexOf('bundle') === -1 && location.indexOf('set') === -1) {
        $('.option__button--active').trigger('click');
      }

      clearInterval(checkInterval);
    }
  }, 100);
}

$(document).ready(function () {
  // when the product page loads, if no variant is selected, we need to pick queen
  // waitForSwatchesAndClick(); 

  // when accessibility is clicked, we just want the link to work as per nomrla
  $('body').on('click','.c-inherit',function(e) {
    var text = $(this).text().trim().toLowerCase();
 //   console.log('my text is ' + text);
    if (text === 'accessibility') {
      e.preventDefault();
      window.location.href = $(this).attr('href');
    }
  });

  /* // when the product page loads, if no variant is selected, we need to pick queen
  var selectedVariant = $('#product-variant-selected').text().trim();
  var location = window.location.href;
  //   console.log('my selected variant is ' + selectedVariant);
  if ((selectedVariant === 'none' || selectedVariant === '') && (location.indexOf('set') === -1 && location.indexOf('bundle') === -1)) {
    console.log('trying to click a button');
    $('button[data-value="Queen"]').click();
    $('button[data-value="Full/Queen"]').click();
  }
  else {
    // reclick the size button if it is selected so that we reset color swatch
    if (location.indexOf('bundle') === -1 && location.indexOf('set') === -1) {
      $('.option__button--active').trigger('click');
    }
  } */

  function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function copyJWT() {
  const jwt = localStorage.getItem("alia-jwt");
  if (!jwt) return;
  setCookie("alia-jwt", jwt, 365 * 10);
}

function loadJWT() {
  const jwt = getCookie("alia-jwt");
  if (!jwt) return;
  localStorage.setItem("alia-jwt", jwt);
}

(() => {
  loadJWT();
  setInterval(copyJWT, 500);
})();
  if ($('.swatch-priority-container').length > 0) {
  //  console.log('Swatch priority containers found. Starting process for each container.');
  
    $('.swatch-priority-container').each(function() {
      let firstSwatchSet = false; // Track if the first priority swatch has been set for this container
  
      // Find the current container’s priority text items
      $(this).find('.swatch-priorities').each(function() {
        var text = $(this).text().trim();
   //     console.log('Checking swatch priority text:', text);
  
        // Move up to the parent of swatch-priority-container, then find the swatch__group-buttons for this container
        var swatchGroup = $(this).closest('.swatch-priority-container').parent().find('.swatch__group-buttons');
        if (swatchGroup.length === 0) {
      //    console.log('No swatch__group-buttons found by moving up to the parent. Here’s the container HTML:', $(this).closest('.swatch-priority-container').parent().html());
          return; // Skip to the next iteration if no swatch group found
        }
  
        // Find the button with the text value in this swatch group
        var swatchButton = swatchGroup.find('.js-swatch__button[data-value="'+text+'"]');
        if (swatchButton.length === 0) {
     //     console.log('No swatch button found with data-value:', text, ' in swatch group. Swatch group HTML:', swatchGroup.html());
          return; // Skip to the next iteration if no button found
        }
  
        if (!firstSwatchSet) {
          // Place the initial priority swatch at the top
          swatchButton.prependTo(swatchGroup);
       //   console.log('Set first priority swatch to:', text, 'for this container.');
          firstSwatchSet = true; // Mark that we’ve set the first priority swatch for this container
        } else {
          // Append any additional prioritized swatches after the first one in this container
          var firstSwatch = swatchGroup.children('.js-swatch__button').first();
          swatchButton.insertAfter(firstSwatch);
      //    console.log('Appended', text, 'after the first priority swatch:', firstSwatch.data('value'), 'for this container.');
        }
      });
  
      // Optionally, click the new first swatch in each swatch group to auto-select it
      var firstButton = $(this).parent().find('.swatch__group-buttons .js-swatch__button').first();
      if (firstButton.length > 0) {
        firstButton.trigger('click');
      //  console.log('Clicked first swatch button:', firstButton.data('value'), 'for this container.');
      } else {
     //   console.log('No swatch button found to click in this group.');
      }
    });
  } else {
   // console.log('No swatch priority containers found.');
  }
  // regardless after everything runs, we need to put the data url in the href position
  $('.swatch-link-dt').each(function() {
    var dataUrl = $(this).attr('data-url');
    $(this).attr('href',dataUrl);
  });
  // we also turn off the swatch button functionality
  $('.collection').find('.js-swatch__button').each(function() {
    $(this).css('cursor','pointer');
  });
  $('body').on('click','.collection .js-swatch__button',function(e) {
    console.log('clicked');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
        // Find the closest parent with the class 'js-card-wrapper'
                if ($(this).hasClass('mobile-swatch-button')) {
        var cardWrapper = $(this).parent().parent().parent().attr('data-url');
                }
                else {
         var cardWrapper = $(this).attr('data-url');
                }
        console.log('my href is ' + cardWrapper);
        if (cardWrapper) {
        // Check if the cardWrapper exists and then redirect to its href
          window.location.href = cardWrapper;
        }
  
  });
    $(".sticker-media__wrapper").on("click", function () {
      const $img = $(this).find("img");

      if ($img.css("animation-play-state") === "running" || $img.css("animation-play-state") === "initial") {
        // Stop the animation
        $img.css({
          "animation-play-state": "paused",
          "-webkit-animation-play-state": "paused",
        });
      } else {
        // Start the animation
        $img.css({
          "animation-play-state": "running",
          "-webkit-animation-play-state": "running",
        });
      }
    });

  /* section selectors */
  if ($(".selector-item").length > 0) {
    $(".selector-item").on("click", function () {
      var targetSection = $(this).attr("data-section");
      console.log("selector: "+targetSection);
      $(".product-selector-wrapper").removeClass("initial active");
      $("#"+targetSection).addClass("active");
      $('.selector-item').removeClass('initial option__button--active');
      $('.selector-item.'+targetSection).addClass('option__button--active');

      /* click initial color */
      $('.js-main-product.active .swatch__button--active').click();
    });
  }
  
  $(".swatch__group-buttons:not(.is_bundle) .swatch__button--color").on("click", function (e) {
    if($('.active .js-product-media-slider').hasClass('slick-initialized')){
      console.log('slick already loaded');
    }
    else{
      console.log('need to initialize slick');
      try {
        $('.js-product-media-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          dotsClass: 'slick-dots slick-thumb grid-container',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                variableWidth: true,
                dots: true
              }
            }
          ]
        });
      } catch (error) {
        console.error("An error occurred:", error.message);
      }
      if(e.which) {
          custom_updateDots();  
        }
    }
  });
  
  function custom_updateDots(){
    console.log('update dots');
    
      const slides = Array.from(
      document.querySelectorAll('.slick-track .slick-slide:not(.slick-cloned)')
    )
    const dots = Array.from(document.querySelectorAll('.slick-dots li'))
    let element = null
    for (let index = 0; index < dots.length; index++) {
      element = document.createElement('span')
      element.className =
        'product-image-wrapper product-image-wrapper-constrained product-thumb'
      element.innerHTML =
        slides[index].querySelector('.active .product-slide').innerHTML
      dots[index].querySelector('button').appendChild(element)
    } 
  }
  (function () {
  const vids = document.querySelectorAll('video[autoplay]');
  vids.forEach(v => {
    v.muted = true;          // property-level (important on iOS)
    v.playsInline = true;
  });

  const tryPlay = () => vids.forEach(v => v.play().catch(()=>{}));

  // try immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryPlay, { once:true });
  } else {
    tryPlay();
  }

  // fallback on first gesture
  window.addEventListener('touchstart', tryPlay, { once:true, passive:true });
  window.addEventListener('click', tryPlay, { once:true });
})();
});